import type { CitiesTranslation } from './types'

/**
 * Arabic translations for Cities domain
 */
export const citiesTranslationAr: CitiesTranslation = {
  // Page/Section level
  title: 'المدن',
  subtitle: 'إدارة المدن داخل المناطق الجغرافية',

  // Actions
  addCity: 'إضافة مدينة',
  editCity: 'تعديل المدينة',
  deleteCity: 'حذف المدينة',

  // Drawer Headers
  addCityDescription: 'أدخل البيانات لإنشاء مدينة جديدة',
  editCityDescription: 'قم بتحديث بيانات المدينة أدناه',
  viewCityDescription: 'عرض معلومات المدينة',

  // Search and states
  searchPlaceholder: 'البحث في المدن...',
  noCities: 'لا توجد مدن',
  noCitiesDescription:
    'لم يتم تكوين أي مدن بعد. أضف أول مدينة لك لبدء إدارة المواقع.',
  addFirst: 'أضف أول مدينة',

  // Form fields
  code: 'رمز المدينة',
  codePlaceholder: 'مثال: RYD, JED',
  name: 'اسم المدينة (إنجليزي)',
  namePlaceholder: 'مثال: Riyadh',
  nameArabic: 'اسم المدينة (عربي)',
  nameArabicPlaceholder: 'مثال: الرياض',
  stateProvince: 'المحافظة/الولاية (إنجليزي)',
  stateProvincePlaceholder: 'مثال: Riyadh Province',
  stateProvinceArabic: 'المحافظة/الولاية (عربي)',
  stateProvinceArabicPlaceholder: 'مثال: منطقة الرياض',
  salesDistrict: 'منطقة المبيعات SAP',
  salesDistrictPlaceholder: 'مثال: 0001',
  basicInformation: 'المعلومات الأساسية',
  arabicOptional: 'العربية (اختياري)',
  region: 'المنطقة',
  selectRegion: 'اختر المنطقة',
  country: 'البلد',
  selectCountry: 'اختر البلد',
  status: 'الحالة',

  // Status values
  active: 'نشط',
  inactive: 'غير نشط',
  all: 'الكل',

  // Stats
  totalCities: 'إجمالي المدن',
  activeCities: 'نشطة',
  inactiveCities: 'غير نشطة',

  // Table headers
  table: {
    code: 'الرمز',
    name: 'الاسم',
    region: 'المنطقة',
    country: 'البلد',
    stateProvince: 'المحافظة/الولاية',
    salesDistrict: 'منطقة المبيعات',
    status: 'الحالة',
    actions: 'الإجراءات',
  },

  // Card content
  card: {
    region: 'المنطقة',
    country: 'البلد',
    noRegion: 'لم يتم تحديد منطقة',
    noCountry: 'لم يتم تحديد بلد',
  },

  // Messages
  messages: {
    createSuccess: 'تم إنشاء المدينة',
    createSuccessDescription: 'تم إنشاء المدينة الجديدة بنجاح.',
    updateSuccess: 'تم تحديث المدينة',
    updateSuccessDescription: 'تم تحديث المدينة بنجاح.',
    deleteSuccess: 'تم حذف المدينة',
    deleteSuccessDescription: 'تم إزالة المدينة.',
    deleteConfirm: 'حذف المدينة',
    deleteConfirmDescription:
      'هل أنت متأكد من حذف هذه المدينة؟ قد يؤثر ذلك على العناوين والمواقع.',
    loadError: 'فشل تحميل المدن. يرجى المحاولة مرة أخرى.',
  },

  // Validation
  validation: {
    codeRequired: 'رمز المدينة مطلوب',
    codeInvalid: 'رمز المدينة يجب أن يكون أبجدي رقمي وبأحرف كبيرة',
    nameRequired: 'اسم المدينة مطلوب',
    regionRequired: 'المنطقة مطلوبة',
  },

  // Filter
  filter: {
    all: 'جميع الحالات',
    active: 'النشطة فقط',
    inactive: 'غير النشطة فقط',
    byRegion: 'تصفية حسب المنطقة',
    allRegions: 'جميع المناطق',
  },
}
